import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

const teamMembers = [
  { name: 'Sushant Medikondla', role: 'CEO', bio: 'Sushant leads TeensMoney with a vision to empower young people financially, and specializes in coding and website development. In his free time, he enjoys competing in DECA and watching the Chicago Bears.' },
  { name: 'Jaden Ahn', role: 'CMO', bio: 'Jaden specializes in marketing and outreach, ensuring TeensMoney reaches as many students as possible. In his free time, he competes in DECA and FCCLA, and loves to play golf.' },
  { name: 'Alex Dobrev', role: 'COO', bio: 'Alex manages operations and logistics, keeping TeensMoney running smoothly and efficiently. Alex loves to play volleyball and compete in DECA in his free time.' },
];

const AboutUs = () => {
  return (
    <Container style={{ padding: '40px', textAlign: 'center' }}>
      <h3 style={{ fontWeight: 'bold', fontSize: '32px', marginBottom: '20px' }}>About Us</h3>
      <p style={{ fontSize: '18px', color: '#333', marginBottom: '40px' }}>
        TeensMoney is dedicated to helping young people gain financial literacy through interactive tools, real-world simulations, and expert insights. Meet the team behind our vision:
      </p>
      <Row className="justify-content-center">
        {teamMembers.map((member, index) => (
          <Col key={index} xs={12} sm={6} md={3} className="mb-4">
            <Card style={{ border: 'none', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', borderRadius: '10px' }}>
              <Card.Body>
                <Card.Title style={{ fontSize: '20px', fontWeight: 'bold' }}>{member.name}</Card.Title>
                <Card.Text style={{ fontSize: '16px', color: '#555', fontWeight: 'bold' }}>{member.role}</Card.Text>
                <Card.Text style={{ fontSize: '14px', color: '#777' }}>{member.bio}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default AboutUs;
